import React, { Component } from "react"
import TableContratos from "./TableContratos"
import Layout from "../Layout"
import { Loading, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"

export default class Contratos extends Component {
  constructor() {
    super()
    this.getContratos = this.getContratos.bind(this)
    this.filter = this.filter.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.state = {
      contratos: [],
      filtered: [],
      currentPage: 1,
      filteredCurrentPage: 1,
      showTable: false,
      pageCount: "",
      filteredPageCount: 1,
      searchActive: false
    }
  }
  componentWillMount() {
    this.getContratos(this.state.currentPage)
  }
  getContratos(page) {
    ApiHelper.getContratos(page, (contratos, error) => {
      if (contratos) {
        this.setState({
          contratos: contratos.data,
          showTable: true,
          pageCount: contratos.last_page
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(text) {
    var searchText = text.toLowerCase()
    if (searchText !== undefined && searchText !== "" && searchText !== null) {
      this.setState(
        {
          searchActive: true
        },
        () => {
          ApiHelper.searchContratos(searchText, 1, (contratos, error) => {
            if (contratos) {
              this.setState({
                filtered: contratos.data,
                showTable: true,
                filteredPageCount: contratos.last_page
              })
            } else {
              this.setState({
                httpError: error
              })
            }
          })
        }
      )
    } else {
      this.setState({
        searchActive: false
      })
    }
  }
  handlePageChange(data) {
    window.scrollTo(0, 0)
    if (!this.state.searchActive) {
      this.getContratos(data.selected + 1)
    }
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableContratos
            pageCount={
              this.state.searchActive
                ? this.state.filteredPageCount
                : this.state.pageCount
            }
            handlePageClick={this.handlePageChange}
            filter={event => this.filter(event.target.value)}
            onDelete={this.getContratos}
            sizeClass=""
            title="Contratos"
            subtitle="Listagem de todos os contratos"
            backgroundColor="as-blue"
            rows={
              this.state.searchActive
                ? this.state.filtered
                : this.state.contratos
            }
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratos/Contratos.js